import { render, staticRenderFns } from "./ChallengePartner.vue?vue&type=template&id=a99c4ecc&scoped=true&"
import script from "./ChallengePartner.vue?vue&type=script&lang=js&"
export * from "./ChallengePartner.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePartner.vue?vue&type=style&index=0&id=a99c4ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99c4ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a99c4ecc')) {
      api.createRecord('a99c4ecc', component.options)
    } else {
      api.reload('a99c4ecc', component.options)
    }
    module.hot.accept("./ChallengePartner.vue?vue&type=template&id=a99c4ecc&scoped=true&", function () {
      api.rerender('a99c4ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/challenges/ChallengePartner.vue"
export default component.exports